import { render, staticRenderFns } from "./ModalMessage.vue?vue&type=template&id=a5ba0eea&scoped=true&"
import script from "./ModalMessage.vue?vue&type=script&lang=js&"
export * from "./ModalMessage.vue?vue&type=script&lang=js&"
import style0 from "./ModalMessage.vue?vue&type=style&index=0&id=a5ba0eea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5ba0eea",
  null
  
)

export default component.exports